import {DefaultClass} from "./DefaultClass";
import {utils} from "../../../../../shop/frontend/web/js/utils";

/**
 *  Класс для страницы услуг
 * @extends DefaultClass
 */
export class Service extends DefaultClass {
	constructor() {
		super();
		this.$service = $(".service");
		this.$serviceId = this.$service.data("id");
		this.$serviceButton = $(".js-service-button");
		this.$bottom = $("#js-bottom");
		this.$serviceBuy = $("#js-service-button");
		this.$serviceSum = $("#js-sum");
		this.$serviceInputs = $(".js-service-count");
		this.$ticketsItems = $("#js-tickets-items");
		this.$bottomClear = $("#js-bottom-clear");
		this.$bottomCount = $("#js-bottom-count");
		this.$bottomWord = $("#js-bottom-word");
		this.$bottomPull = $("#js-bottom-pull");
		this.template = $("#js-ticket-template")[0];
		this.$count = $(".js-count");
	}

	init() {
		this.fetchCart();
		this.addActionToCount();
		this.addActionToRemove();

		if (!this.isDesktop.matches) {
			this.getLanguages();
			this.addActionToPull();
			this.addActionToClear();
		}

		this.addActionToBuy();
	}

	fetchCart() {
		this.getCartCount().then(res => {
			if (res.length) {
				$.each(res, (i, order) => {
					$.each(order.carts, (index, cart) => {
						const serviceId = cart.service_id;
						if (serviceId) {
							const service = $(`.service__item[data-id="${serviceId}"]`);
							service.data("max", Number(service.data("max")) - 1);
						}
					});
				});
			}
		});
	}

	addActionToCount() {
		let sum = Number(this.$serviceSum.text());

		this.$serviceButton.on("click", e => {
			const $element = $(e.currentTarget);
			const $count = $element.parents(".service__count");
			const $block = $element.parents(".service__item");
			const $form = $element.parents("form");
			this.maxTickets = Number($form.data("max"));
			const id = $block.data("id");
			const price = Number($block.find(".js-service-price").text());
			const name = $block.find(".js-service-name").text();
			const $input = $count.find(".js-service-count");

			let count = Number(this.$bottomCount.text());
			let value = Number($input.val());
			if ($element.hasClass("js-service-minus")) {
				value -= 1;
				count -= 1;
				if (value <= 0) {
					value = 0;
					$element.attr("disabled", "true");
					if ($element.data("is-first")) {
						sum -= price;
						$element.data("is-first", "false");
					}
				} else {
					sum -= price;
				}

				if (count <= 0) {
					count = 0;
				}
				this.removeTicket(price);
				$element.parent().find(".js-service-plus").removeAttr("disabled");
			}

			if ($element.hasClass("js-service-plus")) {
				if (!this.checkMax($form, $input)) return false;
				value += 1;

				if (value >= 99) {
					value = 99;
					$element.attr("disabled", "true");
				} else if ($element.parents(".service__inner_pushkin").length && value >= 1) {
					sum = sum + price;
					$element.attr("disabled", "true");
				} else {
					sum = sum + price;
					count += 1;
				}
				$element
					.parent()
					.find(".js-service-minus")
					.removeAttr("disabled")
					.data("is-first", "true");
				this.insertDataToTicket(name, price, id);
			}

			$input.val(value);
			$input.removeClass("active");
			if (value) $input.addClass("active");
			$input.data("prev", value);

			this.$serviceSum.text(sum);

			this.checkPrice();
		});
	}

	insertDataToTicket(name, price, id) {
		const $fragment = $(document.importNode(this.template.content, true));
		$fragment.find(".js-ticket-price").text(price);
		$fragment.find(".js-ticket-sector").text(name);
		$fragment.find(".js-ticket-place").text("Входной билет");
		$fragment.find(".js-tickets-remove").data("id", id);
		this.$ticketsItems.append($fragment);
	}

	addActionToRemove() {
		$(document).on("click", ".js-tickets-remove", e => {
			const $element = $(e.currentTarget);
			const id = $element.data("id");
			const $block = $(`.service__block[data-id="${id}"]`);
			const price = Number($block.find(".js-service-price").text());
			const $input = $block.find(".js-service-count");

			$input.val(Number($input.val()) - 1);
			$element.parents(".tickets__item").remove();
			this.$serviceSum.text(Number(this.$serviceSum.text()) - price);
			this.checkPrice();
		});
	}

	removeTicket(price) {
		const $ticketItems = $(`.tickets__item`);
		let isBreak = false;
		$.each($ticketItems, (index, item) => {
			const $item = $(item);
			const currentPrice = Number($item.find(".js-ticket-price").text());
			if (currentPrice === price) {
				if (!isBreak) {
					$item.remove();
					isBreak = true;
				}
			}
		});
	}

	checkPrice() {
		const price = Number(this.$serviceSum.text());
		this.$serviceBuy.attr("disabled", true);

		if (price !== 0) this.$serviceBuy.removeAttr("disabled");
	}

	checkMax(form, $input) {
		const inputs = $(".js-service-count");
		let count = 0;
		inputs.each((i, item) => {
			if ($input.attr("name") !== $(item).attr("name")) {
				count += Number($(item).val());
			}
		});
		count += Number($input.val());
		if (count >= this.maxTickets) {
			alert("Вы набрали максимальное число билетов");
			return false;
		}
		return true;
	}

	addActionToPull() {
		this.$bottomPull.on("click", () => {
			this.$bottom.toggleClass("open");
			$("html").toggleClass("overflow-hidden");
		});
	}

	addActionToClear() {
		this.$bottomClear.on("click", () => {
			this.$serviceSum.text(0);
			this.$bottom.removeClass("active");
			this.$serviceInputs.val(0);
			this.$bottomCount.text(0);
			this.$bottomWord.text("");
			this.$ticketsItems.html("");
		});
	}

	addActionToBuy() {
		this.$serviceBuy.on("click", e => {
			e.preventDefault();
			const serviceItemsInputs = $(".service__items .js-service-count");
			let hasTicket = [];
			serviceItemsInputs.each((i, item) => {
				const form = $(item).parents(".service__form")
				if (Number($(item).val()) !== 0) {
					const id = form.data("id");

					const currentPromise = new Promise((resolve, reject) => {
						$.ajax({
							url: `/cart/scope-add-no-redirect/${id}`,
							data: form.serialize(),
							type: 'POST',
							beforeSend: () => {
								$("#js-overlay").show();
							},
							success: response => {
								resolve(JSON.parse(response));
							},
							error: error => {
								reject(new Error(error.responseText))
							}
						})
					})
					hasTicket.push(currentPromise);
				}
			});
			if (hasTicket.length) {
				Promise.all([...hasTicket])
					.then(() => {
						window.location.replace("/orders/cart");
					})
					.catch(x => {
						console.error(x);
						alert(x)
					})
					.finally(()=>{
						$("#js-overlay").hide();
					})
			}
		});
	}
}
